._container_3vl0g_1 {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 18px; }

._toggleWrapper_3vl0g_7 {
  width: 40px; }

._toggleSwitch_3vl0g_10 {
  align-items: center;
  display: flex;
  gap: 12px; }

._content_3vl0g_15 {
  padding-left: 52px; }

._groupsList_3vl0g_18 {
  display: flex;
  gap: 6px;
  flex-wrap: wrap; }
